module.exports = __webpack_public_path__ + "static/media/resumeB.6f0f6985.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/resumeB.svg
// module id = 553
// module chunks = 0